import { Row, Section } from '../../forms/ui/atoms';
import { FORM_UI_COLORS as C, FORM_UI_FONT } from '../../forms/ui/tokens';
import { INPUT_STYLE } from '../../forms/ui/atoms';
import { BranchingEditor } from './BranchingEditor';
import {
  fieldsAvailableForBranching,
  gotoTargets,
  useSurveyBuilderStore,
} from './store';

/**
 * Right-pane "Page" tab — page label plus its compound branching rules. Reads
 * the selected page from the builder store.
 */
export function PageSettings() {
  const pages = useSurveyBuilderStore((s) => s.pages);
  const selectedPageId = useSurveyBuilderStore((s) => s.selectedPageId);
  const updatePageLabel = useSurveyBuilderStore((s) => s.updatePageLabel);
  const addRule = useSurveyBuilderStore((s) => s.addRule);
  const removeRule = useSurveyBuilderStore((s) => s.removeRule);
  const updateRule = useSurveyBuilderStore((s) => s.updateRule);
  const addCondition = useSurveyBuilderStore((s) => s.addCondition);
  const removeCondition = useSurveyBuilderStore((s) => s.removeCondition);
  const updateCondition = useSurveyBuilderStore((s) => s.updateCondition);

  const page = pages.find((p) => p.id === selectedPageId) ?? null;
  if (!page) {
    return (
      <div style={{ fontSize: 12, color: C.faint, fontFamily: FORM_UI_FONT, lineHeight: 1.5 }}>
        Select a page from the left rail to edit its label and branching.
      </div>
    );
  }

  const available = fieldsAvailableForBranching(pages, page.id);
  const targets = gotoTargets(pages, page.id);

  return (
    <div style={{ fontFamily: FORM_UI_FONT }}>
      <Row label="PAGE TITLE">
        <input value={page.label} onChange={(e) => updatePageLabel(page.id, e.target.value)} style={INPUT_STYLE} />
      </Row>

      <Section title="BRANCHING">
        <BranchingEditor
          rules={page.branching_rules}
          availableFields={available}
          gotoTargets={targets}
          onAddRule={() => addRule(page.id)}
          onRemoveRule={(ruleId) => removeRule(page.id, ruleId)}
          onUpdateRule={(ruleId, patch) => updateRule(page.id, ruleId, patch)}
          onAddCondition={(ruleId) => addCondition(page.id, ruleId)}
          onRemoveCondition={(ruleId, i) => removeCondition(page.id, ruleId, i)}
          onUpdateCondition={(ruleId, i, patch) => updateCondition(page.id, ruleId, i, patch)}
        />
      </Section>
    </div>
  );
}
